export function humanReadableBytes(bytes: number, si: boolean = false) {
  const unit = si ? 1000 : 1024
  const i = Math.floor(Math.log(bytes) / Math.log(unit))
  return ((bytes / Math.pow(unit, i)).toFixed(2) as any) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}

export const readBlobAsArrayBuffer = async (blob: Blob): Promise<ArrayBuffer | string> => {
  return new Promise((res, rej) => {
    const reader = new FileReader()

    reader.readAsArrayBuffer(blob)

    reader.onerror = () => rej('Failed to load array buffer')
    reader.onloadend = () => res(reader.result)
  })
}
